import React from "react";
import { Viewer } from "@react-pdf-viewer/core";
import { Link } from "react-router-dom";

const Brochure = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <div className="row m-5" style={{ justifyContent: "space-between" }}>
        <Link
          to="/"
          className="btn btn-secondary"
          style={{ justifyContent: "center", alignSelf: "center" }}
        >
          Back To Home
        </Link>
        <a
          className="btn btn-secondary"
          style={{ alignSelf: "auto" }}
          href="Vijaynagar_Biotech.pdf"
          download
        >
          Download
        </a>
      </div>
      <Viewer fileUrl="Vijaynagar_Biotech.pdf" />
    </div>
  );
};

export default Brochure;
